'use strict';
const angular = require('angular');

export class LetterAddressDownloadModalComponent {
  /*@ngInject*/
  constructor() {
  }

  getAddress(address) {
    try {
      return `${address.street}, ${address.city} ${address.state}, ${address.zip}`;
    } catch (e){
      return "-";
    }
  }

  $onInit() {
    this.config = this.resolve.config;

    this.addresses = this.config.addresses.map(adr => {

      let primaryMark = adr.isPrimary ? " (Primary)" : "";

       return {
         group: adr.group,
         name: this.getAddress(adr) + " (" + adr.type + ")" + primaryMark,
         json: adr
       }
    });
  };

  adrChanged(){
    this.addressb64 = btoa(JSON.stringify(this.selectedAddress));
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

}

export default angular.module('conduu.letterAddressDownloadModalComponent', [])
  .component('letterAddressDownloadModal', {
    template: require('./letter-address-download-modal.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: LetterAddressDownloadModalComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/letter-address-download-modal/letter-address-download-modal.component.js